import WaitingList from '../admin/WaitingList';
export default WaitingList;
